import { gql } from '@apollo/client';
import { TaxFragment } from '../fragments/TaxFragment';
/**
 * @const TaxesQuery
 * @since 1.0.0
 */
export const TaxesQuery = gql `
  query TaxesQuery($input: TaxesInput) {
    taxes(input: $input) {
      ...TaxFragment
    }
  }

  ${TaxFragment}
`;
